// Store-connect celebration strings — EN + TR.
//
// One shared success ceremony for EVERY marketplace connect (Etsy / Shopify /
// Amazon / eBay — Volkan direction 2026-08-01 after the live eBay connect
// landed with zero feedback). Title is parametric by provider name; the
// next-steps list is provider-aware (the "Publish to eBay" step renders for
// eBay only).
//
// Source: components/StoreConnectedCelebration.tsx.

import type { LocalizedDict } from '../index'

export type StoreCelebrationStrings = {
  title: (providerName: string) => string
  genericTitle: string
  fallbackStore: string
  nextStepsHeading: string
  steps: {
    listingsMirror: (providerName: string) => string
    orderIntake: string
    publishEbay: string
    manage: string
  }
  actions: {
    listFirstProduct: string
    skip: string
  }
}

export const storeCelebrationI18n: LocalizedDict<StoreCelebrationStrings> = {
  en: {
    title: (providerName) => `Your ${providerName} store is connected!`,
    genericTitle: 'Your store is connected!',
    fallbackStore: 'Connected store',
    nextStepsHeading: 'What happens next',
    steps: {
      listingsMirror: (providerName) =>
        `Your ${providerName} listings sync into My Listings automatically.`,
      orderIntake:
        'New orders from this store flow into Pexify automatically. If something blocks them, the store card shows it.',
      publishEbay:
        'Push products to your store with "Publish to eBay" from My Listings.',
      manage:
        'Manage this connection anytime from Settings → Store Integrations.',
    },
    actions: {
      listFirstProduct: 'List your first product',
      skip: 'Skip for now',
    },
  },
  tr: {
    title: (providerName) => `${providerName} mağazan bağlandı!`,
    genericTitle: 'Mağazan bağlandı!',
    fallbackStore: 'Bağlı mağaza',
    nextStepsHeading: 'Sırada ne var',
    steps: {
      listingsMirror: (providerName) =>
        `${providerName} ilanların otomatik olarak My Listings’e senkronlanır.`,
      orderIntake:
        'Bu mağazanın yeni siparişleri otomatik olarak Pexify’a gelir. Engelleyen bir durum olursa mağaza kartında görürsün.',
      publishEbay:
        'Ürünlerini mağazana göndermek için My Listings’teki "Publish to eBay"i kullan.',
      manage:
        'Bu bağlantıyı istediğin zaman Ayarlar → Mağaza Entegrasyonları’ndan yönetebilirsin.',
    },
    actions: {
      listFirstProduct: 'İlk ürününü listele',
      skip: 'Şimdilik geç',
    },
  },
}
